import config from 'SrcConfig'
import VueCookies from 'vue-cookies'
import ApiAdapter from '@/api'

import vm from './vm'
import router from './router'
import store from './store'
import * as types from './store/types'

const api = ApiAdapter(store)

// Set Account ----------------------------------------

let account = VueCookies.get(types.ACCOUNT_COOKIE)
if (account) {
  store.commit(types.SET_ACCOUNT, {
    value: account,
    cookies: VueCookies
  })
}

// ----------------------------------------

vm.$on('redirectOnForbidden', err => {
  const conf = config.auth.forbiddenErrorConfigs.find(o => o.error === err)
  vm.$nextTick(() => router.push(conf ? conf.redirectPath : '/login'))
})

vm.$on('logout', () => {
  api.account.logout()
  .catch(() => {})
  .then(() => {
    store.commit(types.UNSET_ACCOUNT, VueCookies)
    vm.$nextTick(() => router.push('/login'))
  })
})

// ----------------------------------------

export function guard (path, auth, next) {
  const redirectPath = (path === config.homeUrl) ? '/login' : `/login?returnUrl=${path}`

  if (!auth) return next()

  if (!store.state.$account) return next(redirectPath)

  const needsRoles = auth.roles && auth.roles.length
  const hasNeededRoles = needsRoles ? api.account.isInAnyOfRoles(auth.roles) : true

  if (!hasNeededRoles) return next(redirectPath)


  const accountSettingsKeyName = `${config.auth.userType}Account`

  Promise.all([
    api.settings.get(accountSettingsKeyName),
    api.account.refreshStatus()
  ]).then(() => {
    const accountSettings = api.settings[accountSettingsKeyName]

    const conf = config.auth.forbiddenErrorConfigs.find(conf => {
      const isRequiredGlobally = accountSettings[conf.settingsKey]
      const userHasStatus = api.account.hasStatus(conf.status)

      const isRequiredOnRoute = auth.statuses && auth.statuses.includes(conf.status)
      const isAllowed = auth[conf.allowKey]
      
      return (isRequiredGlobally || isRequiredOnRoute) && !userHasStatus && !isAllowed
    })

    const disallowNavigation = config.auth.forbiddenErrorConfigs.find(conf => {
      const isRequiredGlobally = accountSettings[conf.settingsKey]
      const userHasStatus = api.account.hasStatus(conf.status)

      return isRequiredGlobally && !userHasStatus && conf.disallowNavigation
    })

    if (disallowNavigation) store.commit(types.SET_ALLOW_NAVIGATION, false)
    else store.commit(types.SET_ALLOW_NAVIGATION, true)

    next(conf ? (conf.redirectPath || redirectPath) : undefined)
  })
  .catch(() => {
    return next(redirectPath)
  })
}
